module.exports = ":host {\r\n  display: block;\r\n  width: 100%;\r\n}\r\n\r\n.places-address-input {\r\n  width: 100%;\r\n  box-sizing: border-box;\r\n}\r\n"